module.exports = __webpack_public_path__ + "img/go-live-shop.707deb4b.svg";